import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { escape2Html } from '@/util/util';
export default {
  name: 'Editor',
  props: {
    initialContent: {
      type: String,
      required: true,
      default: '<em>editable text</em>'
    },
    element: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    html: function html() {
      return this.replaceSpacesWithNbsp(this.initialContent);
    },
    emptyContent: function emptyContent() {
      var content = escape2Html(this.html.replace(/<[^>]*>/g, ''));
      return content === "\u200B" || !content;
    },
    tipContent: function tipContent() {
      var tipMapper = {
        title: '请输入学程标题',
        text: '请输入文本',
        H1: '请输入一级标题',
        H2: '请输入二级标题',
        H3: '请输入三级标题',
        H4: '请输入四级标题',
        H5: '请输入五级标题',
        exercise: '请输入习练说明（选填）'
      };
      return tipMapper[this.element.elementType] || '请输入';
    }
  },
  methods: {
    replaceSpacesWithNbsp: function replaceSpacesWithNbsp(input) {
      var edit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var regex = /(?![^<>]*>)(\s)/g;
      var result = input ? input.replace(regex, '&nbsp;') : ''; // &nbsp;  //.replace(/\u200B/g, '')
      if (!edit) {
        result = result.replace(/(<p(?:\s[^>]*)?>)(\s*<\/p>)/gi, '$1<br class="ProseMirror-trailingBreak">$2');
      }
      return result;
    }
  }
};